import { RefObject, useEffect, useRef } from "react";

import { isDefined } from "@utils/helpers";

import { useLanguage } from "@context/language.context";

import { ZOOM_BREAKPOINT, markerIconUrl } from "../storeSearch.config";
import { useMap } from "./useMap.hook";

const BASE_QUERY = (locale: string) => `user.locale:="${locale}"`;

export const useStoresOverlay = (mapElementRef: RefObject<HTMLDivElement>) => {
    const storeOverlayRef = useRef<woosmap.map.StoresOverlay>();
    const { getLocale } = useLanguage();

    const map = useMap(mapElementRef);

    useEffect(() => {
        if (!isDefined(map)) return;

        storeOverlayRef.current = new woosmap.map.StoresOverlay({
            breakPoint: ZOOM_BREAKPOINT,
            rules: [],
            default: {
                color: "#B90000",
                size: 6,
                minSize: 1,
                icon: {
                    url: markerIconUrl,
                    scaledSize: {
                        height: 27,
                        width: 22,
                    },
                },
            },
        });
        storeOverlayRef.current.setMap(map);
        storeOverlayRef.current.setQuery(BASE_QUERY(getLocale()));
    }, [map]);

    const setMapQuery = (query: string | undefined) => {
        storeOverlayRef.current?.setQuery(query);
    };

    const setMapSelection = (selection: object) => {
        storeOverlayRef.current?.setSelection(selection);
    };

    const clearMapSelection = () => {
        storeOverlayRef.current?.clearSelection();
    };

    return {
        setMapQuery: setMapQuery,
        setMapSelection: setMapSelection,
        clearMapSelection: clearMapSelection,
    };
};
